module.exports = __webpack_public_path__ + "img/qrcode.e260a79d.jpg";